import { useState, useEffect } from "react"

// Components
import LandingHeader from "src/components/layout/landing/desktop/header"
import Calculator from "src/components/layout/landing/desktop/calculator"
import SimplifyBorrowing from "src/components/layout/landing/desktop/simplify-borrowing"
import Acceptors from "src/components/layout/landing/desktop/acceptors"
import LandingFooter from "src/components/layout/landing/desktop/footer"
import GeneralModal from "../../../common/modal-general"
import ClubPopup from "../../../layout/landing/components/simplify-borrowing-items/jetclub-modal"

const DesktopLanding = ({ merchantData }) => {
  // Use States
  const [downloaded, setDownloaded] = useState(false)
  const [showCluModal, setShowCluModal] = useState(false)

  // dom
  useEffect(() => {
    setDownloaded(true)
    setShowCluModal(false)
  }, [])

  const renderLanding = () => {
    // if (!downloaded) {
    //   return (
    //     <Stack
    //       direction='row'
    //       justifyContent='center'
    //       sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}
    //     >
    //       <DotLoading color='primary' />
    //     </Stack>
    //   )
    // }
    if (downloaded) {
      return (
        <>
          {showCluModal && (
            <GeneralModal open={showCluModal}>
              <ClubPopup />
            </GeneralModal>
          )}
          <LandingHeader />
          <Acceptors merchantData={merchantData} />
          <Calculator />
          <SimplifyBorrowing />
          <LandingFooter />
        </>
      )
    }
  }

  return <>{renderLanding()}</>
}

export default DesktopLanding
